import { useQuery } from '@tanstack/react-query';
import { useLocalStorage } from 'usehooks-ts';
import { QueryKey } from '@/Config/api/queryKey';
import { ChangelogEntry } from '@/Domain/api/Changelog/dto/ChangelogEntry.dto';

const LAST_SEEN_STORAGE_KEY = 'qc_changelog_last_seen_at';

interface UseChangelogResult {
  entries: ChangelogEntry[];
  isLoading: boolean;
  isError: boolean;
  hasUnseen: boolean;
  markAllSeen: () => void;
}

export const useChangelog = (): UseChangelogResult => {
  const query = useQuery<ChangelogEntry[]>({ queryKey: [QueryKey.changelog.list] });
  const [lastSeenAt, setLastSeenAt] = useLocalStorage<string | null>(LAST_SEEN_STORAGE_KEY, null);

  const entries = query.data ?? [];
  const newestDate = entries[0]?.date;
  const hasUnseen =
    !!newestDate && (lastSeenAt === null || new Date(newestDate) > new Date(lastSeenAt));

  return {
    entries,
    isLoading: query.isLoading,
    isError: query.isError,
    hasUnseen,
    markAllSeen: () => setLastSeenAt(new Date().toISOString()),
  };
};
